import { useTranslation } from 'react-i18next';
import { MenuCategory, MenuItem } from '@/mocks/menuData';
import ProductCard from './ProductCard';

interface CategorySectionProps {
  category: MenuCategory;
  items: MenuItem[];
}

export default function CategorySection({ category, items }: CategorySectionProps) {
  const { t } = useTranslation();

  if (items.length === 0) return null;

  const categoryLabel = category.labelKey && t(category.labelKey) !== category.labelKey ? t(category.labelKey) : (category.label || category.name);
  const itemLabel = items.length === 1 ? t('menu_items_label') : t('menu_items_label_plural');

  return (
    <section id={`cat-${category.id}`} className="mb-16 scroll-mt-24">
      {/* Category Header */}
      <div className="flex items-center gap-4 mb-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-[#F57F25]/10 border border-[#F57F25]/20 rounded-lg">
            <i className={`${category.icon || 'ri-restaurant-line'} text-[#F57F25] text-lg`}></i>
          </div>
          <div>
            <h2 className="text-white font-black text-xl md:text-2xl uppercase tracking-tight">
              {categoryLabel}
            </h2>
            <p className="text-white/30 text-xs uppercase tracking-widest">
              {items.length} {itemLabel}
            </p>
          </div>
        </div>
        <div className="flex-1 h-px bg-gradient-to-r from-[#F57F25]/30 to-transparent"></div>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {items.map((item) => (
          <ProductCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}
